import { render, staticRenderFns } from "./CandleNote.vue?vue&type=template&id=51522c16&scoped=true"
import script from "./CandleNote.vue?vue&type=script&lang=js"
export * from "./CandleNote.vue?vue&type=script&lang=js"
import style0 from "./CandleNote.vue?vue&type=style&index=0&id=51522c16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51522c16",
  null
  
)

export default component.exports